/* src/app/system-utils/input-button-popup/input-button-popup.component.scss */
.buttonicon {
  padding-left: 6px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  padding-right: 6px;
  display: flex;
  align-items: flex-end;
  padding-bottom: 2px;
}
.div {
  display: flex;
  width: 100%;
}
.field {
  padding-right: 6px;
  width: 100%;
}
/*# sourceMappingURL=input-button-popup.component.css.map */
